/*
 *  past                 present
 *   | -------> t -------> |
 * startDate            endDate
 */

/**
 * A range of time, with start being in the past & end being in the future
 */
export type DateRange = { startDate: Date; endDate: Date };

/**
 * A range of time, with start being in the past & end being in the future
 */
export type DateRangeTuple = [startDate: Date, endDate: Date];
